import { z } from 'zod'

import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

import { BidIdSchema } from '../unique-id.models.ts'
import { SurveyFeedbackSchema } from './common.ts'
import { SurveyTypeSchema } from './survey-types.ts'

export const [
  OpportunityToBidAcceptedByMakerReasons,
  OpportunityToBidAcceptedByMakerReasonSchema,
  OpportunityToBidAcceptedByMakerReasonEnum,
] = EnumBuilder(
  'great-brand',
  'good-project-for-portfolio',
  'aligns-with-values-and-culture',
  'lucrative-budget',
  'high-confidence-in-doing-an-excellent-job',
  'industry-matches-experience',
  'existing-relationship-with-customer',
  'other'
)

export type OpportunityToBidAcceptedByMakerReason = ZodInfer<
  typeof OpportunityToBidAcceptedByMakerReasonSchema
>

export const OpportunityToBidAcceptedByMakerResponsesSchema =
  z.discriminatedUnion('reason', [
    z.object({
      reason: OpportunityToBidAcceptedByMakerReasonSchema.extract(['other']),
      feedback: SurveyFeedbackSchema,
    }),
    z.object({
      reason: OpportunityToBidAcceptedByMakerReasonSchema.exclude(['other']),
      feedback: SurveyFeedbackSchema.optional(),
    }),
  ])

export type OpportunityToBidAcceptedByMakerResponses = ZodInfer<
  typeof OpportunityToBidAcceptedByMakerResponsesSchema
>

export const OpportunityToBidAcceptedByMakerSurveyDetailsSchema = z.object({
  surveyType: SurveyTypeSchema.extract([
    'opportunity-to-bid-accepted-by-maker',
  ]),
  bidId: BidIdSchema,
  responses: OpportunityToBidAcceptedByMakerResponsesSchema,
})
